import React from 'react'
import LayoutConnector, { ConnectorProps as LayoutProps } from 'containers/Layout'
import { LoaderOverlay, Loader } from './styles'

const Component = ({ isReady }: LayoutProps) => {
  if (isReady) {
    return null
  }

  return (
    <LoaderOverlay>
      <Loader />
    </LoaderOverlay>
  )
}

export default LayoutConnector(Component)
